import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, Typography } from '@mui/material';

import { MplTrans } from '@mopla/i18';

import { MplButton, MplModal } from '../../..';

export interface IFreeCancellationCancelModalProps {
	onClose: () => void;
	onConfirm: () => void;
	isCanceling: boolean;
	open: boolean;
}

export const FreeCancellationCancelModal: FC<
	IFreeCancellationCancelModalProps
> = ({ onClose, onConfirm, isCanceling, open }) => {
	const { t } = useTranslation('tickets');

	return (
		<MplModal
			open={open}
			testId="ConfirmationModal-MplModal"
			title={t('cancellation_flow.confirmation.title')}
			isLoading={isCanceling}
			content={
				<Stack gap={3}>
					<Typography variant="body1">
						<MplTrans
							ns="tickets"
							i18nKey="cancellation_flow.confirmation.body"
							context="free_with_highlight"
						/>
					</Typography>
				</Stack>
			}
			buttons={
				<>
					<MplButton
						fullWidth
						onClick={onConfirm}
						data-testid="savedTicket-removingConfirmation-cancelBooking-button"
					>
						{t('button.cancel', { context: 'ride' })}
					</MplButton>
					<MplButton
						fullWidth
						variant="outlined"
						onClick={onClose}
						data-testid="savedTicket-removingConfirmation-abort-button"
					>
						{t('button.abort', { context: 'ride' })}
					</MplButton>
				</>
			}
		/>
	);
};
